import { createSelector, MemoizedSelector } from '@ngrx/store';
import { FaqOverviewResponse } from '../../model/faq-items.model';
import { FaqItemsState, getFaqItemsState } from '../reducers';
import * as FaqOverviewSearchFeature from '../reducers/faq-overview-search.reducer';
import { FAQ_OVERVIEW_SEARCH_FEATURE_KEY } from '../reducers/faq-overview-search.reducer';


export const selectLoading: MemoizedSelector<FaqOverviewSearchFeature.FaqOverviewSearchState, boolean>
  = createSelector(
  getFaqItemsState,
  (state: FaqItemsState) => state[FAQ_OVERVIEW_SEARCH_FEATURE_KEY].loading
);

export const selectResponse: MemoizedSelector<FaqOverviewSearchFeature.FaqOverviewSearchState, FaqOverviewResponse>
  = createSelector(
  getFaqItemsState,
  (state: FaqItemsState) => state[FAQ_OVERVIEW_SEARCH_FEATURE_KEY].response
);
